import React, { useState, useContext, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import EditDetailsModal from './modals/editDetailsModal'
import EditCompanyDetailsModal from './modals/editCompanyDetailsModal'
import AddMembersModal from './modals/addMembersModal'
import { VendorContext } from '../../../contexts/vendorContext'
import { getCompanyProfile } from '../../../services/vendorService'
import VendorUsers from './vendorUsers'
import { AuthContext } from '../../../contexts/authContext'
import { getCustomClaims } from '../../../services/authService'
// import styles from './dashboard.module.css'

function Main() {
  const vendorContext = useContext(VendorContext)
  const authContext = useContext(AuthContext)
  const [permission, setPermission] = useState({
    vendors: {
      read: false,
      write: false
    },
    vendorUsers: {
      read: false,
      write: false
    }
  })

  const vendorId = vendorContext?.profile?.vendorId

  useEffect(() => {
    if (vendorId && !vendorContext?.companyProfile) {
      getCompanyProfile(vendorId).then(companyProfile => {
        vendorContext?.setCompanyProfile(companyProfile)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorId])

  useEffect(() => {
    if (authContext?.customClaims && authContext?.customClaims?.vendorId) {
      const perms = authContext?.customClaims?.role?.permissions
      if (perms) {
        const newPermission = {
          vendors: {
            read: perms.vendors?.read ?? false,
            write: perms.vendors?.write ?? false
          },
          vendorUsers: {
            read: perms.vendorUsers?.read ?? false,
            write: perms.vendorUsers?.write ?? false
          }
        }
        setPermission(newPermission)
      }
    } else {
      getCustomClaims()
        .then(claims => {
          authContext?.setCustomClaims(claims)
        })
        .catch(err => {
          console.error('Custom claims error:', err)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authContext?.customClaims])

  // Modal States
  const [showEditDetailsModal, setShowEditDetailsModal] = useState(false)
  const [showAddMembersModal, setShowAddMembersModal] = useState(false)
  const [
    showEditCompanyDetailsModal,
    setShowEditCompanyDetailsModal
  ] = useState(false)

  return (
    <>
      <>
        <EditDetailsModal
          data-testid="modal-edit-details"
          show={showEditDetailsModal}
          handleClose={() => {
            setShowEditDetailsModal(false)
          }}
        />

        <EditCompanyDetailsModal
          data-testid="modal-edit-company"
          show={showEditCompanyDetailsModal}
          handleClose={() => {
            setShowEditCompanyDetailsModal(false)
          }}
          vendor={vendorContext?.companyProfile || undefined}
        />

        <AddMembersModal
          data-testid="modal-add-members"
          show={showAddMembersModal}
          handleClose={() => {
            setShowAddMembersModal(false)
          }}
        />
      </>

      <Row>
        <Col>
          <h1 className="largeTitle" data-testid="dashboard-welcome">
            Dashboard
          </h1>
        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          <img
            src={vendorContext?.profile?.avatarUrl || '/profilepic.png'}
            className="avatar mb-4"
            alt="user avatar"
          />
          <p>Hi {vendorContext?.profile?.firstName}!</p>
          <button
            data-testid="edit-details"
            className="mochi-button orange"
            onClick={() => {
              setShowEditDetailsModal(true)
            }}
          >
            Edit details{' '}
          </button>
        </Col>
      </Row>

      <Row>
        <Col>
          {permission.vendors.write && permission.vendorUsers.read && (
            <Row>
              {/* {permission.vendors.write && (
                <Col lg={3} id="revenue" className="mb-5">
                  <h2>Revenue</h2>
                  <div className={'box ' + styles.boxRevenueEqualHeight}>
                    <h6>Total Revenue - Month</h6>
                    <span className="gray-text">$ 30,000.00</span>
                  </div>
                </Col>
              )} */}

              {permission.vendorUsers.read && (
                <Col id="users" className="mb-5">
                  <h2>Members</h2>
                  <div className="box">
                    <VendorUsers
                      showWriteActions={permission.vendorUsers.write}
                      onAddMemberClick={() => {
                        setShowAddMembersModal(true)
                      }}
                    />
                  </div>
                </Col>
              )}
            </Row>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <h2>Company information</h2>
          <div className="box">
            <Row>
              <Col lg={4} className="mb-3">
                <h6>Company</h6>
                <p className="gray-text">
                  {vendorContext?.companyProfile?.name || '-'}
                </p>
                <h6>Company e-mail</h6>
                <p className="gray-text">
                  {vendorContext?.companyProfile?.email || '-'}
                </p>
                <h6>Company phone number</h6>
                <p className="gray-text">
                  {vendorContext?.companyProfile?.phonenumber || '-'}
                </p>
              </Col>
              <Col lg={4} className="mb-3">
                <h6>Company description</h6>
                <p className="gray-text">
                  {vendorContext?.companyProfile?.bio || '-'}
                </p>
              </Col>
              <Col lg={4} className="mb-3">
                <h6>Company Logo</h6>
                <img
                  src={vendorContext?.companyProfile?.logoUrl || '/image.png'}
                  style={{
                    width: '160px',
                    height: '120px',
                    borderRadius: '15px'
                  }}
                  alt="company logo"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="text-center">
                {permission.vendors.write && (
                  <button
                    data-testid="edit-company"
                    className="mochi-button orange"
                    onClick={() => {
                      setShowEditCompanyDetailsModal(true)
                    }}
                  >
                    Edit details
                  </button>
                )}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default Main
